import { render } from "./ModalCustomer.vue?vue&type=template&id=73b90f9e&scoped=true"
import script from "./ModalCustomer.vue?vue&type=script&lang=js"
export * from "./ModalCustomer.vue?vue&type=script&lang=js"

import "./ModalCustomer.vue?vue&type=style&index=0&id=73b90f9e&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b90f9e"]])

export default __exports__